import { Collapse, Checkbox } from 'antd'

import Box from '~/core/Box'
import Text from '~/core/Text'
import styles from '../styles.css'

import HTS5106NewInfoRequirements from './HTS5106NewInfoRequirements'

interface HTS5106InfoPropsType {
    checked5106: boolean
    onCheckboxChange: Function
    isHTSSubmissionTimeExpired: boolean
}

const HTS5106Info = (props: HTS5106InfoPropsType) => {
    const { checked5106, onCheckboxChange, isHTSSubmissionTimeExpired } = props

    const { Panel } = Collapse

    return (
        <>
            <Box direction="col">
                <Box direction="col" width="930px">
                    <Box className={styles.htsSubHeader}>
                        3. Is your Form 5106 already on file?
                    </Box>
                    <Box className={styles.htsSubHeaderDescription}>
                        If you or someone in your company has ordered overseas
                        parts from Fictiv, or if you have used FedEx as an
                        international shipping carrier to handle international
                        orders check the box below. No further action is
                        required, unless you need to update the information on
                        the form.
                    </Box>
                    <Box padding="24px 0">
                        <Checkbox
                            defaultChecked={checked5106}
                            onChange={() => onCheckboxChange()}
                            style={{ paddingRight: '10px' }}
                            disabled={isHTSSubmissionTimeExpired}
                        />{' '}
                        <Text
                            fontWeight={400}
                            fontSize="16px"
                            color="blackAlpha65"
                        >
                            I have submitted my CBP Form 5106 with the carrier I
                            selected{' '}
                        </Text>
                    </Box>
                </Box>
                <Box
                    className={checked5106 ? styles.displayNone : ''}
                    direction="col"
                    width="630px"
                >
                    <HTS5106NewInfoRequirements />
                </Box>
            </Box>
            <Box
                className={checked5106 && styles.displayNone}
                justifyContent="between"
            >
                <Collapse
                    className={styles.collapse}
                    style={{ paddingTop: 20 }}
                    bordered={false}
                >
                    <Panel
                        key={1}
                        className={styles.panel}
                        header="I'm not sure if my company has imported
                                    goods before"
                    >
                        If you're not sure whether your company has imported via
                        FedEx before, then fill out and submit your Form 5106 to
                        FedEx to be certain that your information is on file.
                        Please note that FedEx removes profiles for companies
                        that are inactive, so even if your company had a Form
                        5106 on file in the past, it may still be worthwhile to
                        re-submit.
                    </Panel>
                    <Panel
                        key={2}
                        className={styles.panel}
                        header="Why do I need to provide this
                                    information?"
                    >
                        Providing your EIN/SSN helps FedEx to establish your
                        identity as the importer of record. The bank account,
                        shipping and billing address are used to prove to
                        Customs that the importer has the means to pay any
                        applicable duties.
                    </Panel>
                    <Panel
                        key={3}
                        className={styles.panel}
                        header="How will the customs duties be
                                    collected?"
                    >
                        The customs duties will be charged to the FedEx account
                        owner directly.
                    </Panel>
                </Collapse>
            </Box>
        </>
    )
}

export default HTS5106Info
